import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Accordion, Modal, ModalBody, Spinner } from "react-bootstrap";
import { GoDotFill } from "react-icons/go";
import { ThreeDots } from "react-loader-spinner";
import InfiniteScroll from "react-infinite-scroll-component";
import { array, bool, func, number, object } from "prop-types";

import {
  emptyString,
  individualStorePerformanceConstants,
} from "../../../../views/shared-screens/constants";
import { individualStorePerformanceActions } from "../../../../views/shared-screens/redux/actions";
import { UTCToDateTimeFormatWithoutSeconds } from "../../../utility";
import { useSpinner } from "../../hooks";

const { GET_CUSTOMER_CONVERSATIONS, GET_ALL_INTERNAL_NOTES } =
  individualStorePerformanceConstants;

const ConversationAllInternalNotesModal = (props) => {
  const {
    show,
    title,
    orderId,
    brandId,
    animate,
    modalSize,
    locationId,
    closeModal,
    customerId,
    customerName,
    resetCustomerConversations,
    getCustomerConversationsNotes,
    individualStorePerformanceReducer: { allConversation },
  } = props;

  // Show loading while a request is running.
  const spinner = useSpinner();

  //Getting data from backend
  const getData = (from) => {
    const body = {
      customerId, orderId, ...(brandId && { brandId: Number(brandId) }), ...(locationId && { storeId: Number(locationId) }),
    }
    getCustomerConversationsNotes(body, {
      from: from || 0,
      take: 15,
    });
  };

  //Get conversations on scroll
  const getConversations = () => {
    getData(allConversation.length);
  };

  //Get data when page renders
  useEffect(() => {
    resetCustomerConversations();
    getData(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getConversationContent = () => {
    if (spinner(GET_CUSTOMER_CONVERSATIONS)) {
      return (
        <div className="d-flex justify-content-center p-2">
          <ThreeDots ariaLabel="loading-indicator" />
        </div>
      );
    }

    if (allConversation?.length > 0 && !orderId) {
      return (
        <Accordion className="customer-conversations-orderIds-modal shadow">
          {allConversation.map((conversation) => (
            <Accordion.Item
              key={conversation.orderId}
              eventKey={conversation.orderId}
              aria-label="conversation-accordion"
            >
              <Accordion.Header
                className="accordion-header border-bottom"
                aria-label="conversation-accordion-header"
              >
                <div className="d-flex justify-content-between align-items-center w-100">
                  <div>
                    <small className="mb-1">Survey Completion Date:</small>
                    <h5 className="fw-bolder text-dark">
                      {UTCToDateTimeFormatWithoutSeconds(
                        conversation.surveyCompletionDate
                      )}
                    </h5>
                  </div>
                  <div className="px-lg-2 px-1">
                    <p className="fw-bold mb-1 small">Last Contributor:</p>
                    <div>
                      <p className="m-0 small">
                        {conversation?.lastContributor?.name}
                      </p>
                      <p className="m-0 small">
                        {UTCToDateTimeFormatWithoutSeconds(
                          conversation?.lastContributor?.submissionDate
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </Accordion.Header>
              <Accordion.Body
                className="p-2"
                aria-label="conversation-accordion-body"
              >
                {getNotesContent(conversation?.notes)}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      );
    }

    if (
      orderId &&
      allConversation.length > 0 &&
      allConversation[0].notes.length > 0
    ) {
      return allConversation[0].notes.map((note) => (
        <div className="rounded mb-1 border border-2" key={note.id}>
          <div className="d-flex justify-content-between position-relative p-1">
            <p className="bold-5 mb-0 py-2 px-1 text-break">{note.message}</p>
          </div>
          <div className="d-flex justify-content-between align-items-end py-1 px-2 bg-primary  bg-opacity-10">
            <small>
              {UTCToDateTimeFormatWithoutSeconds(note.updatedAt)}
              {note?.isEdited && (
                <small className="text-primary fw-bold px-1">Edited</small>
              )}
            </small>
            <small>
              <span className="fw-bold">Added By:</span> {note.addedBy}
            </small>
          </div>
        </div>
      ));
    }

    if (orderId) {
      return <p className="m-0 p-2 text-center">No Notes Found</p>;
    }

    return <p className="m-0 p-2 text-center">No Conversation Found</p>;
  };

  const getNotesContent = (notes) => {
    if (spinner(GET_ALL_INTERNAL_NOTES)) {
      return (
        <div className="text-center p-2">
          <Spinner animation="border" role="status" size="sm" />
        </div>
      );
    }

    if (notes?.length > 0) {
      return (
        <div className="consumer-response-notes custome-sidebar">
          {notes.map((note) => (
            <div className="border border-2 rounded mb-1 mx-3" key={note.id}>
              <div className="d-flex justify-content-between p-1">
                <p className="bold-5 mb-0 p-1 text-break">{note.message}</p>
              </div>
              <div className="d-flex justify-content-between align-items-end px-2 py-1 bg-primary bg-opacity-10">
                <small className="d-flex align-items-end">
                  {UTCToDateTimeFormatWithoutSeconds(note.updatedAt)}
                  {note?.isEdited && (
                    <span className="text-primary px-1 d-flex align-items-end">
                      <span className="d-md-none">
                        <GoDotFill size={10} color="#1B77FD" />
                      </span>
                      <span className="d-md-block d-none fw-bold">Edited</span>
                    </span>
                  )}
                </small>
                <small>
                  <span className="fw-bold">Added By:</span> {note.addedBy}
                </small>
              </div>
            </div>
          ))}
        </div>
      );
    }

    return <p className="p-2 m-0 text-center">No Internal Notes Found</p>;
  };

  return (
    <Modal
      centered
      show={show}
      size={modalSize}
      onHide={closeModal}
      animation={animate}
      className="react-survey-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {title}
          {customerName && (
            <span className="text-secondary"> : {customerName}</span>
          )}
        </Modal.Title>
      </Modal.Header>
      <ModalBody>
        <div
          className="conversation-orderIds custome-sidebar"
          id="conversation-orderIds"
        >
          <InfiniteScroll
            dataLength={allConversation.length}
            next={getConversations}
            hasMore={
              allConversation.length > 0 && allConversation.length % 15 === 0
            }
            loader={
              spinner(GET_CUSTOMER_CONVERSATIONS) ? (
                <span className="px-3">
                  <ThreeDots ariaLabel="loading-indicator" />
                </span>
              ) : (
                emptyString
              )
            }
            scrollableTarget="conversation-orderIds"
          >
            {getConversationContent()}
          </InfiniteScroll>
        </div>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  individualStorePerformanceReducer: state.individualStorePerformanceReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomerConversationsNotes: (data, body) =>
    dispatch(
      individualStorePerformanceActions.getCustomerConversationsNotes(
        data,
        body
      )
    ),
  resetCustomerConversations: () =>
    dispatch(individualStorePerformanceActions.resetCustomerConversations()),
});

//Validate props types
ConversationAllInternalNotesModal.propTypes = {
  show: bool.isRequired,
  animate: bool.isRequired,
  closeModal: func.isRequired,
  customerId: number.isRequired,
  allConversation: array.isRequired,
  getCustomerConversationsNotes: func.isRequired,
  individualStorePerformanceReducer: object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConversationAllInternalNotesModal);
